import { validatePersonalDetailsCommonFields } from '@/core/validation/common/personal-details';

export async function validatePersonalDetails(field) {
  return validatePersonalDetailsCommonFields(field);
}
